export const listaInvitados = {
  "familia-osorio-martinez": {
    nombre: "Fam. Osorio Martinez",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-jaziel-celina": {
    nombre: "Jaziel y Celina",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-alexander": {
    nombre: "Alexander Vela y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-yazmin": {
    nombre: "Yazmin Ledesma y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-lupita-palma": {
    nombre: "Lupita Palma y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-nancy-maciel": {
    nombre: "Nancy Maciel y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-gaby-zavala": {
    nombre: "Gaby Zavala y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-alonso-alcocer": {
    nombre: "Fam. Alonso Alcocer",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-elia-ramirez": {
    nombre: "Elia Ramirez y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-omar-gonzalez": {
    nombre: "Omar Gonzales y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-carmen-saavedra": {
    nombre: "Carmen Saavedra y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-genaro": {
    nombre: "Genaro y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-david-gaby": {
    nombre: "Gaby y David",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-alonso-carmona": {
    nombre: "Fam. Alonso Carmona",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-villanueva-santoyo": {
    nombre: "Fam. Villanueva Santoyo",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-rodriguez-santoyo": {
    nombre: "Fam. Rodriguez Santoyo",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-santoyo-vega": {
    nombre: "Fam. Santoyo Vega",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-santoyo-anguiano": {
    nombre: "Fam. Santoyo Anguiano",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-barbosa-santoyo": {
    nombre: "Fam. Barbosa Santoyo",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-alonso-vargas": {
    nombre: "Fam. Alonso Vargas",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-rios-moreno": {
    nombre: "Fam. Rios Moreno",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-itzel-eric": {
    nombre: "Itzel y Eric",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-isai-aranza": {
    nombre: "Isai y Aranza",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-rosales-andrade": {
    nombre: "Fam. Rosales Andrade",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-rosales-barbosa": {
    nombre: "Fam. Rosales Barbosa",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-alcocer-barbosa": {
    nombre: "Fam. Alcocer Barbosa",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-areli": {
    nombre: "Areli Mosqueda y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-linda-rios": {
    nombre: "Linda Rios y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-santoyo-ortega": {
    nombre: "Fam. Santoyo Ortega",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-cindy-barron": {
    nombre: "Cindy Barron y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  },
  "familia-carlos-maciel": {
    nombre: "Carlos Maciel y Familia",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jenny",
    telefono: ""
  }
};
